 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","audio-player-container":"audio-player-container","bi-carousel~bi-landing":"bi-carousel~bi-landing","bi-landing":"bi-landing","bi-discover":"bi-discover","book-insight-reader":"book-insight-reader","book-insight":"book-insight","hb-fullscreen-loader":"hb-fullscreen-loader","nav-links":"nav-links","not-logged-in":"not-logged-in","reader-mode":"reader-mode","insights-player~nonfiction-player":"insights-player~nonfiction-player","nonfiction-player":"nonfiction-player","authentication-forms":"authentication-forms","bi-categories-carousel":"bi-categories-carousel","collaborator-bio":"collaborator-bio","memod-footer":"memod-footer","newsletter-box":"newsletter-box","bi-carousel":"bi-carousel","bi-thanks":"bi-thanks","start-membership":"start-membership","bi-featured":"bi-featured","book-insight-hero":"book-insight-hero","bookinsight-comment":"bookinsight-comment","bookinsight-summary":"bookinsight-summary","bookinsight-themes":"bookinsight-themes","share-dropdown":"share-dropdown","subscribe-bi":"subscribe-bi","category-pill":"category-pill","reader-bottom-nav":"reader-bottom-nav","reader-header":"reader-header","reader-header-nav":"reader-header-nav","reader-theme":"reader-theme","insights-login-form":"insights-login-form","insights-sign-up-landing-form":"insights-sign-up-landing-form","book-insight-example":"book-insight-example","bi-background":"bi-background","person-role-pill":"person-role-pill","theme-box":"theme-box","email-capture-form":"email-capture-form","player-interface":"player-interface","theme-pill":"theme-pill","theme-divider":"theme-divider","facebook-auth":"facebook-auth","sing-in-form":"sing-in-form","sing-up-form":"sing-up-form","landing-player":"landing-player","audio-player-menu":"audio-player-menu","insights-player":"insights-player"}[chunkId]||chunkId) + "." + {"404":"800b92ac","audio-player-container":"0d3ad4a6","bi-carousel~bi-landing":"fb6045dc","bi-landing":"331a3eae","bi-discover":"c01eb2b5","book-insight-reader":"01b6daac","book-insight":"bbca42bf","hb-fullscreen-loader":"9f2184b7","nav-links":"cdd4652e","not-logged-in":"f3acba4f","reader-mode":"9bfdbaa2","insights-player~nonfiction-player":"f6f88500","nonfiction-player":"b6d98629","authentication-forms":"bf3cc4b3","bi-categories-carousel":"81326d7c","collaborator-bio":"73fc7966","memod-footer":"b6c609b9","newsletter-box":"6ee307ed","bi-carousel":"d4ccb741","bi-thanks":"b9bc4c08","start-membership":"65e6bc45","bi-featured":"5610b98f","book-insight-hero":"38ad0dff","bookinsight-comment":"6ddd89b8","bookinsight-summary":"7d806991","bookinsight-themes":"b7b66fb8","share-dropdown":"b6cda6b4","subscribe-bi":"7abe903b","category-pill":"1f24c469","reader-bottom-nav":"36b6732e","reader-header":"222f215b","reader-header-nav":"46bfc84b","reader-theme":"0281ee87","insights-login-form":"3a45d426","insights-sign-up-landing-form":"213c821b","book-insight-example":"7ca1ccf0","bi-background":"2ee42cf0","person-role-pill":"b9d7fe30","theme-box":"eb7b0c3f","email-capture-form":"ef7e3764","player-interface":"f1ce366d","theme-pill":"2d3a8e58","theme-divider":"5e670cad","facebook-auth":"e08c320b","sing-in-form":"e1eb3422","sing-up-form":"fd2f86c2","landing-player":"49c9fa8b","audio-player-menu":"249f98a7","insights-player":"81056dbd"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"bi-carousel~bi-landing":1,"bi-landing":1,"bi-discover":1,"book-insight-reader":1,"book-insight":1,"hb-fullscreen-loader":1,"nav-links":1,"not-logged-in":1,"reader-mode":1,"authentication-forms":1,"bi-categories-carousel":1,"collaborator-bio":1,"memod-footer":1,"newsletter-box":1,"bi-carousel":1,"bi-thanks":1,"start-membership":1,"bi-featured":1,"book-insight-hero":1,"bookinsight-summary":1,"share-dropdown":1,"subscribe-bi":1,"category-pill":1,"reader-bottom-nav":1,"reader-header":1,"reader-header-nav":1,"reader-theme":1,"insights-sign-up-landing-form":1,"book-insight-example":1,"bi-background":1,"person-role-pill":1,"theme-box":1,"email-capture-form":1,"player-interface":1,"theme-pill":1,"theme-divider":1,"facebook-auth":1,"insights-player":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","audio-player-container":"audio-player-container","bi-carousel~bi-landing":"bi-carousel~bi-landing","bi-landing":"bi-landing","bi-discover":"bi-discover","book-insight-reader":"book-insight-reader","book-insight":"book-insight","hb-fullscreen-loader":"hb-fullscreen-loader","nav-links":"nav-links","not-logged-in":"not-logged-in","reader-mode":"reader-mode","insights-player~nonfiction-player":"insights-player~nonfiction-player","nonfiction-player":"nonfiction-player","authentication-forms":"authentication-forms","bi-categories-carousel":"bi-categories-carousel","collaborator-bio":"collaborator-bio","memod-footer":"memod-footer","newsletter-box":"newsletter-box","bi-carousel":"bi-carousel","bi-thanks":"bi-thanks","start-membership":"start-membership","bi-featured":"bi-featured","book-insight-hero":"book-insight-hero","bookinsight-comment":"bookinsight-comment","bookinsight-summary":"bookinsight-summary","bookinsight-themes":"bookinsight-themes","share-dropdown":"share-dropdown","subscribe-bi":"subscribe-bi","category-pill":"category-pill","reader-bottom-nav":"reader-bottom-nav","reader-header":"reader-header","reader-header-nav":"reader-header-nav","reader-theme":"reader-theme","insights-login-form":"insights-login-form","insights-sign-up-landing-form":"insights-sign-up-landing-form","book-insight-example":"book-insight-example","bi-background":"bi-background","person-role-pill":"person-role-pill","theme-box":"theme-box","email-capture-form":"email-capture-form","player-interface":"player-interface","theme-pill":"theme-pill","theme-divider":"theme-divider","facebook-auth":"facebook-auth","sing-in-form":"sing-in-form","sing-up-form":"sing-up-form","landing-player":"landing-player","audio-player-menu":"audio-player-menu","insights-player":"insights-player"}[chunkId]||chunkId) + "." + {"404":"f22b6a37","audio-player-container":"31d6cfe0","bi-carousel~bi-landing":"c412edf5","bi-landing":"bbc30aa3","bi-discover":"04e0cce5","book-insight-reader":"7b421453","book-insight":"4cd18d01","hb-fullscreen-loader":"f4ee6cec","nav-links":"393d7174","not-logged-in":"86e0919c","reader-mode":"33cc1d97","insights-player~nonfiction-player":"31d6cfe0","nonfiction-player":"31d6cfe0","authentication-forms":"e34860ee","bi-categories-carousel":"cabebab3","collaborator-bio":"a70a40f7","memod-footer":"adba082e","newsletter-box":"6b561249","bi-carousel":"ecb05503","bi-thanks":"a86206d2","start-membership":"fc478a52","bi-featured":"0b4f6410","book-insight-hero":"787f9558","bookinsight-comment":"31d6cfe0","bookinsight-summary":"71a34f09","bookinsight-themes":"31d6cfe0","share-dropdown":"22c42dc3","subscribe-bi":"bf361e2e","category-pill":"3ff3bafc","reader-bottom-nav":"8049f44d","reader-header":"1c28a401","reader-header-nav":"ccc772a0","reader-theme":"82b063ef","insights-login-form":"31d6cfe0","insights-sign-up-landing-form":"1a9d7afa","book-insight-example":"2969d9e1","bi-background":"57e41352","person-role-pill":"52891cbb","theme-box":"e14f719e","email-capture-form":"5a49541e","player-interface":"133ee6a4","theme-pill":"ff570dfd","theme-divider":"aa036cc3","facebook-auth":"c1e904e3","sing-in-form":"31d6cfe0","sing-up-form":"31d6cfe0","landing-player":"31d6cfe0","audio-player-menu":"31d6cfe0","insights-player":"6f3b02dd"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
